import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import ErrorFallback from "./components/ErrorFallback";
import { reportWebVitals } from "./lib/reportWebVitals";
import CookieConsent from "./components/CookieConsent";
import { getStoredConsent } from "./components/CookieConsent";
import { initAnalytics } from "./lib/analytics";

const SENTRY_DSN = "https://d64026a40621a7e0d20379aa0dd28bc4@o4511305378758656.ingest.us.sentry.io/4511306277584896";

const RELEASE =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ||
  (import.meta.env.VITE_COMMIT_SHA as string | undefined) ||
  undefined;

if (SENTRY_DSN && import.meta.env.PROD) {
  const consent = getStoredConsent();
  const analyticsOk = Boolean(consent?.categories.analytics);
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    // Performance tracing and session replay only run after analytics consent.
    tracesSampleRate: analyticsOk ? 0.1 : 0,
    replaysSessionSampleRate: analyticsOk ? 0.05 : 0,
    // Error replay is always allowed (strictly necessary for debugging crashes).
    replaysOnErrorSampleRate: 1.0,
  });
}

initAnalytics();

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={({ error, eventId, resetError }) => (
      <ErrorFallback error={error} eventId={eventId} resetError={resetError} />
    )}
  >
    <HelmetProvider>
      <App />
      <CookieConsent />
    </HelmetProvider>
  </Sentry.ErrorBoundary>
);

reportWebVitals();
